import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from "src/app/core/services/requests.service";

@Injectable({
  providedIn: 'root'
})
export class CargueService {
// ENDPOINT = "http://127.0.0.1:8000/cartera/carguearchivocobradores";
  requestsService: any;
ENDPOINT = getEndpoint('cargue_masivo_cobradores');
constructor(private _http: HttpClient, private _http2: RequestsService) { }

transformEtiquetasToInsert(etiquetas: CargueV[]) {
  return etiquetas ? etiquetas.map((value, index) => {
    value["c_emp"] = getConnection();
    return value;
  }) : []
}

  async cargue(company:string, payload: any): Promise<BasicResponse>{
    const url = `${this.ENDPOINT}/cargue_masivo/${company}`;
    return await this._http2.postLikeJSON(url,payload);
  }

  async procesador(company:string){
    const url = `${this.ENDPOINT}/procesador/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }

}

export class CargueV {
  agencia: string
  tipo_credito: string
  num_cuenta: string
  codigo: string
}
